// src/pages/UniversalLedger/universalLedgerConfig.js
// Central config for all 6 supported account types.
// Add more types here in the future — the UI picks them up automatically.

export const ACCOUNT_TYPE_OPTIONS = [
  {
    value: "debitor",
    label: "Customer",
    searchPlaceholder: "Search customer...",
  },
  {
    value: "creditor",
    label: "Supplier",
    searchPlaceholder: "Search supplier...",
  },
  {
    value: "direct_expense",
    label: "Direct Expense",
    searchPlaceholder: "Search expense account...",
  },
  {
    value: "indirect_expense",
    label: "Indirect Expense",
    searchPlaceholder: "Search expense account...",
  },
  {
    value: "sale_account",
    label: "Sales Account",
    searchPlaceholder: "Search sales account...",
  },
  {
    value: "sale_return",
    label: "Sales Return",
    searchPlaceholder: "Search sales return account...",
  },
  {
    value: "purchase_account",
    label: "Purchase Account",
    searchPlaceholder: "Search purchase account...",
  },
  {
    value: "purchase_return",
    label: "Purchase Return",
    searchPlaceholder: "Search purchase return account...",
  },
  {
    value: "service_account",
    label: "Service Account",
    searchPlaceholder: "Search service account...",
  },
  {
    value: "service_return",
    label: "Service Return",
    searchPlaceholder: "Search service return account...",
  },
  {
    value: "service_expense_account",
    label: "Service Expense Account",
    searchPlaceholder: "Search service expense account...",
  },
 
  {
    value: "cash_in_hand",
    label: "Cash",
    searchPlaceholder: "Search cash account...",
  },
  {
    value: "bank_account",
    label: "Bank",
    searchPlaceholder: "Search bank account...",
  },
  {
    value: "indirect_income",
    label: "Indirect Income",
    searchPlaceholder: "Search income account...",
  },
  {
    value: "direct_income",
    label: "Direct Income",
    searchPlaceholder: "Search income account...",
  },
  {
    value: "loan",
    label: "Loan",
    searchPlaceholder: "Search loan account...",
  },
  {
    value: "capital",
    label: "Capital",
    searchPlaceholder: "Search capital account...",
  },
  {
    value: "investment",
    label: "Investment",
    searchPlaceholder: "Search investment account...",
  },
  {
    value: "deposit_accounts",
    label: "Deposit Account",
    searchPlaceholder: "Search deposit account...",
  },
  {
    value: "current_liability",
    label: "Current Liability",
    searchPlaceholder: "Search liability account...",
  },
  {
    value: "current_assets",
    label: "Current Assets",
    searchPlaceholder: "Search current asset account...",
  },
  {
    value: "fixed_asset",
    label: "Fixed Asset",
    searchPlaceholder: "Search fixed asset account...",
  },
  {
    value: "suspense_accounts",
    label: "Suspense",
    searchPlaceholder: "Search suspense account...",
  },
  {
    value: "dutie_&_tax",
    label: "Duties & Tax",
    searchPlaceholder: "Search tax account...",
  },
  {
    value: "reserve_surplus",
    label: "Reserve & Surplus",
    searchPlaceholder: "Search reserve account...",
  },
    {
    value: "intangible_asset",
    label: "Intangible Asset",
    searchPlaceholder: "Search intangible asset account...",
  },
];

// Quick lookup by value
export const ACCOUNT_TYPE_MAP = Object.fromEntries(
  ACCOUNT_TYPE_OPTIONS.map((o) => [o.value, o])
);